module.exports = __webpack_public_path__ + "img/Charts 1.96e500c2.png";